import { getAxiosErrorMessage } from '@shared/api'

const readMessage = (data: unknown): string | null => {
  const message = (data as { message?: unknown } | null)?.message

  return typeof message === 'string' && message ? message : null
}

/** A `responseType: 'blob'` request gets its error envelope as a Blob too; read the server message out of it. */
export const getBlobErrorMessage = async (err: unknown): Promise<string> => {
  const data = (err as { response?: { data?: unknown } } | null)?.response?.data

  if (data instanceof Blob) {
    try {
      return readMessage(JSON.parse(await data.text())) ?? getAxiosErrorMessage(err)
    } catch {
      return getAxiosErrorMessage(err)
    }
  }

  return readMessage(data) ?? getAxiosErrorMessage(err)
}
